import RoomDetails from './RoomDetails';

export default RoomDetails;
